import React, { useState } from 'react'
import { commitMutation } from 'react-relay'
import { useDispatch, useSelector } from 'react-redux'
import { WalletConstant } from '../../../reducers/wallet.reducer'
import ConfigurationService from '../../../service/ConfigurationService'
import { store, IStore } from '../../../store'
import { updateUserPreference } from '@src/queries/updateUserPreference'
import { updateUserPreferenceMutation } from '@src/queries/__generated__/updateUserPreferenceMutation.graphql'
import Env from '../../../RelayEnvironment'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Search from '../../Elements/Search/Search'
import CurrenciestList from './ListView.currencies'
import { ListViewWrap, SearchWrap } from './ListView.styled'
import { SpecialBonus } from './ListView.special'

import { UserProp } from '@src/stores/auth/user'
import { CurrencyEnum } from '@src/service/coins/coins.types'

interface ListViewProps {
  back?: () => void
  onChange?: (currency: string) => void
  noBalance?: boolean
}

export const ListView: React.FC<ListViewProps> = ({ back, onChange, noBalance, currenciesProp }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const [searchTerm, setSearchTerm] = useState('')

  const wallet = useSelector((store: IStore) => store.wallet)
  const gamblerWallet = wallet.wallets.find((w) => !!w.campaign?.meta?.playable)
  const { activeWallet } = wallet

  const isGamblerWalletActive = gamblerWallet?.virtualId === activeWallet?.virtualId
  const currencies = Object.keys(ConfigurationService.instance.getTradeableCurrencies())

  const setActive = (e: React.MouseEvent | undefined, currency: keyof CurrencyEnum) => {
    e?.preventDefault()
    e?.stopPropagation()

    if (onChange) {
      onChange(currency)
      // return
    }

    let w = store
      .getState()
      .wallet.wallets.find((x) => x.currency.toLowerCase() === currency.toLowerCase() && x.virtualId === 0)
    if (!w) {
      w = {
        balance: 0,
        currency,
        virtual: false,
        virtualId: 0,
      }
      dispatch({ type: WalletConstant.SET_ACTIVE_WALLET, wallet: w })
    } else {
      commitMutation<updateUserPreferenceMutation>(Env, {
        mutation: updateUserPreference,
        variables: { input: { key: UserProp.ACTIVE_COIN, value: w.currency } },
        onCompleted: () => {
          dispatch({ type: WalletConstant.SET_ACTIVE_WALLET, wallet: w })
        },
      })
    }

    if (onChange) {
      onChange(currency)
      // return
    }

    back?.()
  }

  const onSpecialBonusClick = () => {
    if (gamblerWallet) {
      dispatch({ type: WalletConstant.SET_ACTIVE_WALLET, wallet: gamblerWallet })
      return
    }

    history.push('/profile?tab=settings&stab=KYC')
  }

  const onChangeHandler = (value) => {
    setSearchTerm(value)
  }

  return (
    <>
      <SearchWrap>
        <Search onChange={onChangeHandler} initialTerm={searchTerm} width="w-full" height="h-42" />
      </SearchWrap>

      <ListViewWrap>
        <SpecialBonus isGamblerWalletActive={isGamblerWalletActive} onSpecialBonusClick={onSpecialBonusClick} />

        <CurrenciestList
          currencies={currencies}
          searchTerm={searchTerm}
          activeWallet={activeWallet}
          isGamblerWalletActive={isGamblerWalletActive}
          setActive={setActive}
          noBalance={noBalance}
        />
      </ListViewWrap>
    </>
  )
}
